// The app's cache never goes stale (app/queryClient.js), so every visit asks the server again or
// the page edits a week another admin has since changed. No retries: a 403 or 404 is final, and
// the pages show a load error at once rather than after three waits.
export const WORK_SCHEDULE_QUERY_OPTIONS = {
  refetchOnMount: "always",
  retry: false,
};

// The seven days in the order the page shows them. The key's index is the API's weekday
// (0 = Monday), see regular-hours-adapter.js.
export const WORK_DAYS = [
  { key: "monday", label: "Mon", name: "Monday" },
  { key: "tuesday", label: "Tue", name: "Tuesday" },
  { key: "wednesday", label: "Wed", name: "Wednesday" },
  { key: "thursday", label: "Thu", name: "Thursday" },
  { key: "friday", label: "Fri", name: "Friday" },
  { key: "saturday", label: "Sat", name: "Saturday" },
  { key: "sunday", label: "Sun", name: "Sunday" },
];

// Web feature flag for the page and the Time Tracking Clock window; internal-only until
// clocking reads the Work Schedule (API-Q5).
export const WORK_SCHEDULE_FLAG = "WORK_SCHEDULE";

export const REGULAR_HOURS_QUERY_KEY = ["work-schedule", "regular-hours"];

export const CUSTOM_SCHEDULES_QUERY_KEY = ["work-schedule", "custom-schedules"];

export const CLOCK_SETTINGS_QUERY_KEY = ["work-schedule", "clock-settings"];

// F01-2 Copy: Same mode names the field; Different mode names the day's row.
export const MISSING_TIME_ERROR = "Enter a start and finish time.";
export const missingDayHoursError = (dayName) => `Enter hours for ${dayName}.`;

// WS-1.3.
export const NO_WORKING_DAYS_ERROR = "Select at least one working day.";

export const EXCEPTIONS_QUERY_KEY = ["work-schedule", "exceptions"];
